<template>
	<div>
		<div class="container table-actions">
			<div v-if="isImpl" class="btns-container">
				<div
					v-if="REPORT.status === 'Внесены корректировки после утверждения'"
				>
					<button
						class="table-actions-button btn-blue"
						type="button"
						@click="openModalECPList"
					>
						Подписать и отправить все последующие отчеты
					</button>
				</div>
				<div
					v-if="
						!REPORT.withDigitalSign &&
							!(REPORT.status === 'Разрешена корректировка') &&
							!(
								REPORT.status ===
								'Внесены корректировки после утверждения'
							) &&
							!(
								REPORT.status ===
								'Авто-изменения после корректировки'
							) && can_be_sign
					"
				>
					<button
						class="table-actions-button btn-green"
						type="button"
						@click="openModalECP"
					>
						Подписать и отправить
					</button>
				</div>
				<div
					v-if="
						REPORT.status === 'Отклонен утверждающим' ||
							REPORT.status === 'Разрешена корректировка' ||
							REPORT.status === 'Создан' ||
							REPORT.status === 'Редактирован' ||
							REPORT.status ===
								'Внесены корректировки после утверждения'
					"
				>
					<button
						class="table-actions-button btn-blue"
						type="button"
						@click="redirectEdit"
					>
						Редактировать
					</button>
					<!-- <button
						v-if="REPORT.status === 'Подписан утверждающим'"
						class="table-actions-button btn-blue"
						type="button"
						@click="openModalEditApprovedReport()"
					>
						Запрос на редактирование
					</button> -->
				</div>
				<div>
					<button
						v-if="accessLevel(USER.ouser.role, 1) && REPORT.status === 'Подписан утверждающим'"
						class="table-actions-button btn-blue"
						type="button"
						@click="openModalEditApprovedReport()"
					>
						Запрос на редактирование
					</button>
				</div>
        <div v-if="!createReportAllowed && (REPORT.status === 'Создан' || REPORT.status === 'Редактирован' || REPORT.status === 'Подписан исполнителем')">
					<button
						type="button"
						class="table-actions-button btn-green"
						@click="openModalEditApprovedReport()"
					>
						Запрос на сдачу отчётности
					</button>
				</div>
			</div>
			<!-- <div v-if="isImpl">


			</div> -->
			<div
				v-if="
					isImpl &&
						(REPORT.status === 'Создан' ||
							REPORT.status === 'Редактирован')
				"
			>
				<button
					class="table-actions-button btn-red"
					type="button"
					@click="rmReport()"
				>
					Удалить отчёт
				</button>
			</div>
			<div v-if="isApproved">
				<div
					v-if="
						REPORT.withDigitalSign &&
							REPORT.status === 'Подписан исполнителем'
					"
				>
					<button
						type="button"
						class="table-actions-button btn-green"
						@click="openModalECP"
					>
						Утвердить и отправить в КМГ
					</button>
					<!--          <button type="button" class="table-actions-button btn-red" @click="rejectReport()">-->
					<button
						type="button"
						class="table-actions-button btn-red"
						@click="openModalRejectDzo()"
					>
						Отклонить
					</button>
				</div>
				<div
					v-if="
						REPORT.status ===
							'Подписан исполнителем после внесения корректировок'
					"
				>
					<button
						class="table-actions-button btn-blue"
						type="button"
						@click="openModalECPList"
					>
						Подписать и отправить все последующие отчеты
					</button>
				</div>
			</div>
			<div v-if="isRecipient">
				<div
					v-if="REPORT.status === 'Запрос на корректировку'
					"
				>
					<button
						type="button"
						class="table-actions-button btn-red"
						@click="openModalEditRequest()"
					>
						Запрос на корректировку
					</button>
				</div>
			</div>

			<button
				class="table-actions-button btn-green"
				v-if="REPORT.withDigitalSign"
				@click="openModalApprovedPersons"
			>
				Утвердившие
			</button>
			<!--      <button class="table-actions-button btn-yellow" @click="openModal">-->
			<!--        Аналитика-->
			<!--      </button>-->
			<button
				class="table-actions-button btn-blue"
				@click="openModalHistory"
			>
				История
			</button>
			<button
				class="table-actions-button btn-yellow"
				@click="downLoadExcel()"
			>
				Скачать отчет в Excel
			</button>
			<!--      <router-link :to="{ name: 'view-report-place', parra }" class="table-actions-button btn-blue">openMetalPlace</router-link>-->
		</div>

		<div class="table-info">
			<div>
				<p class="table-naming">
					Отчет за
					{{ REPORT.month | getMonth }}
					{{ REPORT.year }}
					"{{ REPORT.dzo ? REPORT.dzo.name : '' }}"
				</p>
			</div>
			<div>
				<button class="status-info">Статус: {{ REPORT.status }}</button>
			</div>
		</div>
		<div class="table-container-inner">
			<table>
				<thead>
					<tr>
						<td class="table-specs" colspan="2" rowspan="2">
							Характеристики
						</td>
					</tr>
					<tr class="tr-fixed-height">
						<th
							class="metall-measure-unit"
							rowspan="2"
							colspan="1"
							scope="colgroup"
						>
							Единица измерения
						</th>
						<!-- Hide Remnant -->
						<th
							class="metall-slot-hidden"
							colspan="3"
							scope="colgroup"
							rowspan="2"
							style="border-top: 1px solid #868686; margin-top: -10px"
						>
							<button
								class="show-btn"
								@click="showRemnantColumns"
							>
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							<p>Показать</p>
							<span>остаток</span>
						</th>
						<th
							class="metall-left-in-stock-botm"
							colspan="3"
							scope="colgroup"
						>
							Остаток металлолома на складе на начало месяца
						</th>
						<th
							class="metall-received"
							colspan="1"
							scope="colgroup"
						>
							<button
								class="hide-btn"
								@click="hideRemnantColumns"
							>
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							Поступление
						</th>
						<th
							class="metall-received"
							colspan="1"
							scope="colgroup"
						>
							Реализация на собственные нужды
						</th>
						<th
							class="metall-received"
							colspan="1"
							scope="colgroup"
						>
							Социальное обязательство
						</th>
						<th
							class="metall-slot-hidden-contract"
							colspan="1"
							rowspan="1"
							style="border-top: 1px solid #868686; margin-top: -10px"
						>
							<button
								class="show-btn"
								@click="showContractColumns"
							>
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							<p>Показать информацию о контракте</p>
						</th>
						<th
							class="metall-information metall-info-contract-cell"
							colspan="11"
							scope="colgroup"
						>
							<button
								class="hide-btn"
								@click="hideContractColumns"
							>
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							Информация по заключенным договорам
						</th>
						<th
							class="metall-left-in-stock-eotm metall-info-notes-cell"
							colspan="2"
							scope="colgroup"
						>
							Остаток металлолома на складе на конец месяца
						</th>
						<th
							class="metall-slot-hidden-notes"
							rowspan="2"
							colspan="1"
							style="
                border-top: 1px solid #868686;
                border-right: 1px solid #868686;
                margin-top: -10px;
              "
						>
							<button class="show-btn" @click="showNotesColumns">
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							<p>Показать</p>
							<span>остаток</span>
						</th>
						<th
							class="metall-notes metall-info-notes-cell"
							rowspan="2"
						>
							<button class="hide-btn" @click="hideNotesColumns">
								<i class="fas fa-arrows-alt-h"></i>
							</button>
							Примечание
						</th>
					</tr>
					<tr>
						<th
							scope="col"
							style="background: #36429e; border: none"
						></th>
						<th
							scope="col"
							style="background: #36429e; border: none"
						></th>
						<th class="metall-slot-hidden" scope="col">...</th>
						<th
							class="metall-left-in-stock-sub-botm expanded"
							scope="col"
						>
							Кол-во
						</th>
						<th class="metall-left-in-stock-sub-botm" scope="col">
							Стоимость оценки
						</th>
						<th
							class="metall-left-in-stock-sub-botm expanded"
							scope="col"
						>
							Сумма
						</th>
						<th class="metall-received-count" scope="col">
							Количество
						</th>
						<th class="metall-slot-hidden-contract" scope="col">
							...
						</th>
						<th class="metall-received-count" scope="col">
							Количество
						</th>
						<th class="metall-received-count" scope="col">
							Количество
						</th>
						<th
							class="metall-info-sub-count metall-info-contract-cell"
							scope="col"
						>
							Общее кол-во по договору
						</th>
						<th
							class="metall-info-sub-realization metall-info-contract-cell"
							scope="col"
						>
							Способ реализации
						</th>
						<th
							class="metall-info-sub-payment metall-info-contract-cell"
							scope="col"
						>
							Условия оплаты
						</th>
						<th
							class="metall-info-sub-naming metall-info-contract-cell"
							scope="col"
						>
							Наименование покупателя
						</th>
						<th
							class="metall-info-sub-bin metall-info-contract-cell"
							scope="col"
						>
							БИН
						</th>
						<th
							class="metall-info-sub-contract-number metall-info-contract-cell"
							scope="col"
						>
							Номер договора
						</th>
						<th
							class="metall-info-sub-date metall-info-contract-cell"
							scope="col"
						>
							Дата договора
						</th>
						<th
							class="metall-info-sub-price metall-info-contract-cell expanded"
							scope="col"
						>
							Цена за ед. тенге
						</th>
						<th
							class="metall-info-sub-sum metall-info-contract-cell"
							scope="col"
						>
							Сумма договора, тенге
						</th>
						<th
							class="metall-info-sub-exported metall-info-contract-cell"
							scope="col"
						>
							Вывезенное количество
						</th>
						<th
							class="metall-info-sub-left metall-info-contract-cell"
							scope="col"
						>
							Остаток по договору
						</th>
						<th
							class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded"
							scope="col"
						>
							Кол-во
						</th>
						<th
							class="metall-left-in-stock-sub-eotm metall-info-notes-cell expanded"
							scope="col"
						>
							Сумма
						</th>
						<th
							class="metall-slot-hidden-notes"
							style="border-right: 1px solid #868686"
						>
							...
						</th>
					</tr>
					<tr>
						<th
							colspan="3"
							class="metall-notes metall-info-notes-cell"
						>
							Общая сумма
						</th>
						<th>
							{{
								commonReportData.common_count_before
									| getNumberFormat
							}}
						</th>
						<th></th>
						<th>
							{{
								commonReportData.common_total_before
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_count_come
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_for_own_needs
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_for_social_commitment
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_contr_count
									| getNumberFormat
							}}
						</th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th></th>
						<th>
							{{
								commonReportData.common_contr_total
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_contr_count_gone
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_contr_count_balance
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_count_after
									| getNumberFormat
							}}
						</th>
						<th>
							{{
								commonReportData.common_total_after
									| getNumberFormat
							}}
						</th>
					</tr>
				</thead>
				<tbody v-for="request in REPORT.requests" :key="request.id">
					<tr
						v-for="contract in request.contracts"
						:key="contract.id"
					>
						<th
							class="t-metall-sub-type metall-color-th"
							scope="rowgroup"
							rowspan="1"
							v-if="request.is_color"
						>
							Цветной металл
						</th>
						<th
							class="t-metall-sub-type metall-color-th"
							scope="rowgroup"
							rowspan="1"
							v-else
						>
							Черный металл
						</th>
						<th class="t-metall-sub-type" scope="row">
							{{ request.category }}
						</th>
						<!-- Note 1. Check if there should be metall-td-hide class on T -->
						<td>T</td>
						<td class="metall-slot-hidden">...</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(
									request.changes,
									'count_before'
								)
							"
							:class="
								getChangeColor(request.changes, 'count_before')
							"
						>
							{{ request.count_before | getNumberFormat }}
						</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(
									request.changes,
									'price_before'
								)
							"
							:class="
								getChangeColor(request.changes, 'price_before')
							"
						>
							{{ request.price_before | getNumberFormat }}
						</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(
									request.changes,
									'total_before'
								)
							"
							:class="
								getChangeColor(request.changes, 'total_before')
							"
						>
							{{ request.total_before | getNumberFormat }}
						</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(request.changes, 'count_come')
							"
							:class="
								getChangeColor(request.changes, 'count_come')
							"
						>
							{{ request.count_come | getNumberFormat }}
						</td>
						<td class="metall-slot-hidden-contract">...</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(
									request.changes,
									'for_own_needs'
								)
							"
							:class="
								getChangeColor(request.changes, 'for_own_needs')
							"
						>
							{{ request.for_own_needs | getNumberFormat }}
						</td>
						<td
							class="metall-td-hide"
							:title="
								getOldTitleValue(
									request.changes,
									'for_social_commitment'
								)
							"
							:class="
								getChangeColor(
									request.changes,
									'for_social_commitment'
								)
							"
						>
							{{
								request.for_social_commitment | getNumberFormat
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_count'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_count'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_count
								) | getNumberFormat
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_method'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_method'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_method
								)
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_conditions'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_conditions'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_conditions
								)
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_impl'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_impl'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_impl
								)
							}}
						</td>
						<td
							class="metall-info-contract-cell bin-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'bin_company'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'bin_company'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.bin_company
								) | splitNumber
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_number'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_number'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_number
								)
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_date'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_date'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_date
								)
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_unit_price'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_unit_price'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_unit_price
								) | getNumberFormat
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_total'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_total'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_total
								) | getNumberFormat
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_count_gone'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_count_gone'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_count_gone
								) | getNumberFormat
							}}
						</td>
						<td
							class="metall-info-contract-cell"
							:title="
								getOldTitleValue(
									contract.contract_changes,
									'contr_count_balance'
								)
							"
							:class="
								getChangeColor(
									contract.contract_changes,
									'contr_count_balance'
								)
							"
						>
							{{
								prettyEmpty(
									contract.contr_count,
									contract.contr_count_balance
								) | getNumberFormat
							}}
						</td>
						<td
							class="metall-slot-hidden-notes"
							style="border-right: 1px solid #868686"
						>
							...
						</td>
						<td
							class="metall-info-notes-cell"
							:title="
								getOldTitleValue(request.changes, 'count_after')
							"
							:class="
								getChangeColor(request.changes, 'count_after')
							"
						>
							{{ request.count_after | getNumberFormat }}
						</td>
						<td
							class="metall-info-notes-cell"
							:title="
								getOldTitleValue(request.changes, 'total_after')
							"
							:class="
								getChangeColor(request.changes, 'total_after')
							"
						>
							{{ request.total_after | getNumberFormat }}
						</td>
						<td
							class="metall-info-notes-cell"
							:title="
								getOldTitleValue(request.changes, 'comment')
							"
							:class="getChangeColor(request.changes, 'comment')"
						>
							{{ contract.comment }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="container">
			<div class="place-view">
				<table>
					<thead>
						<th class="metall-left-in-stock-sub-botm" scope="col">
							Место хранения
						</th>
						<th class="metall-left-in-stock-sub-botm" scope="col">
							Вид металла
						</th>
						<th class="metall-left-in-stock-sub-botm" scope="col">
							Отстаток металла
						</th>
					</thead>
					<tbody
						v-for="metalPlace in metalPlaces"
						:key="metalPlace.id"
					>
						<tr>
							<td class="metall-td-hide">
								{{ metalPlace.place.get_full_name }}
							</td>
							<td class="metall-td-hide">
								{{ metalPlace.request.category_full }}
							</td>
							<td
								:class="
									'metall-td-hide ' +
										getChangeClass(
											metalPlace.old_count_total,
											metalPlace.count_total
										)
								"
								:title="
									getChangeTitle(
										metalPlace.old_count_total,
										metalPlace.count_total
									)
								"
							>
								{{ metalPlace.count_total | getNumberFormat }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="container">


			<!-- auth modal -->
			<section class="auth-modal">
				<!-- Modal Content Wrapper -->
				<div id="auth-modal-content" class="auth-modal-content">
					<div class="modal-info">
						<div
							class="modal-info-inner"
							:class="{ modalInfoEcp: showModalEcp === true }"
						>
							<div v-if="showModalEcp">
								<h3>Подписать через ЭЦП</h3>
								<form
									method="POST"
									id="auth-form"
									@submit.prevent="sendSignXml"
								>
									<div hidden>
										<select id="storageSelect">
											<option value="PKCS12" selected>
												PKCS12
											</option>
										</select>
									</div>

									<p class="auth-moda-explanations">
										Для успешной подписи рекомендуется
										<br />
										выбирать ключ
										<b>GOSTKNCA</b>
									</p>

									<textarea
										hidden
										id="xmlToSign"
										name="xmlToSign"
										v-model="this.REPORT.xmlToSign"
										rows="6"
									></textarea>
									<textarea
										hidden
										class="form-control"
										id="signedXml"
										name="signedXml"
										rows="6"
										readonly
									></textarea>
									<button
										class="auth-choose-cert"
										type="button"
										@click="signXmlCall"
									>
										Выбрать сертификат
									</button>
									<button id="test" type="submit" hidden>
										submit
									</button>
								</form>
							</div>

							<div v-else-if="showModalEcpList">
								<h3>Подписать и отправить</h3>
								<form
									method="POST"
									id="list-form"
									@submit.prevent="sendSignXmlList"
								>
									<div hidden>
										<select id="storageSelectList">
											<option value="PKCS12" selected>
												PKCS12
											</option>
										</select>
									</div>

									<p class="auth-moda-explanations">
										Для успешной подписи рекомендуется
										<br />
										выбирать ключ
										<b>GOSTKNCA</b>
									</p>
									<div
										v-for="(xml, index) in this.xmlsToSing"
										:key="xml"
									>
										<textarea
											:id="'xml_' + index"
											name="xmlToSign"
											:value="xml"
											rows="6"
											hidden
										></textarea>
										<textarea
											:id="'signedXml_' + index"
											:name="'signedXml_' + index"
											rows="6"
											hidden
										></textarea>
									</div>
									<textarea
										hidden
										class="form-control"
										id="signedXmlList"
										name="signedXml"
										rows="6"
										readonly
									></textarea>
									<button
										class="auth-choose-cert"
										type="button"
										@click="signXmlCallList"
									>
										Выбрать сертификат
									</button>
									<button id="test_list" type="submit" hidden>
										submit
									</button>
								</form>
							</div>
							<div v-else-if="showModalHistory">
								<div
									class="history-container"
									v-if="
										historyReports &&
											historyReports.length > 0
									"
								>
									<h2 class="table-title">История отчета</h2>
									<table class="history-table">
										<thead>
											<tr>
												<th>Номер</th>
												<th>Ф.И.О.</th>
												<th>Статус до</th>
												<th>Статус после</th>
												<th>Файл</th>
											</tr>
										</thead>
										<tbody>
											<tr></tr>
											<tr
												v-for="historyReport in historyReports"
												:key="historyReport.id"
												class="history"
											>
												<td>
													{{ historyReport.number }}
												</td>
												<td>
													{{
														historyReport
															.action_user
															.last_name | TitleCase
													}}
													{{
														historyReport
															.action_user
															.first_name | TitleCase
													}}
												</td>
												<td>
													{{
														historyReport.status_before
													}}
												</td>
												<td>
													{{
														historyReport.status_after
													}}
													<span
														v-if="
															historyReport.reject_reason
														"
													>
														.Причина:
														{{
															historyReport.reject_reason
														}}
													</span>
												</td>
												<td v-if="historyReport.edit_file"><a class="link-file" :href="historyReport.edit_file" target="_blank">Скачать</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-else-if="showModalApprovedPersons">
								<div
									class="history-container"
									v-if="REPORT.withDigitalSign"
								>
									<h2 class="table-title">Утвердившие посредством ЭЦП</h2>
									<table class="history-table">
										<thead>
											<tr>
												<th>Ф.И.О.</th>
												<th>Время подписи</th>
											</tr>
										</thead>
										<tbody>
											<tr></tr>
											<tr
												v-for="signLevel in REPORT.reportSignLevel"
												:key="signLevel.id"
												class="history"
											>
												<td>
													{{
														signLevel.sign_user
															.last_name | TitleCase
													}}
													{{
														signLevel.sign_user
															.first_name | TitleCase
													}}
												</td>
												<td>
													{{
														signLevel.sign_date
															| formatDate
													}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div v-else-if="showModalEditApprovedReport">
								<div class="edit-approved-report-modal">
									<h2>
										Для формирования запроса на
										редактирование загрузите скан письма в
										АО "НК "КазМунайГаз" на имя директора
										департамента закупок и снабжения
									</h2>
									<button
										class="uploadScannedDocument"
										type="submit"
									>
										<div class="file-area">
											<input
												type="file"
												name="file"
												ref="file"
												id="file"
												@change="inputChanged"
											/>
											<div class="file-state">
												<div class="success">
													Отлично, файл был загружен
												</div>
												<div class="default">
													Загрузить отсканированный
													документ
												</div>
											</div>
										</div>
									</button>
									<button
										class="w-6/12 block flex sm:inline-flex justify-center items-center transition-all py-4 ease-in-out duration-150 transform hover:scale-110 bg-blue-500 hover:bg-blue-600 px-10 rounded-lg text-white"
										@click="submitFile()"
									>
										Отправить
									</button>
								</div>
							</div>
							<div v-else-if="showModalEditRequest">

								<button
									type="button"
									class="table-actions-button btn-green"
									@click="rejectReport()"
								>
									Разрешаю редактирование
								</button>
								<button
									type="button"
									class="table-actions-button btn-red"
									@click="rejectReportMetall()"
								>
									Отклонить
								</button>
								<embed
									class="embed-file"
									:src="file_url"
									type=""
								/>
							</div>
							<div
								class="reject-block"
								v-else-if="showModalRejectDzo"
							>
								<h4>Причина отклонения</h4>
								<textarea v-model="reason" required></textarea>
								<button
									type="button"
									@click="rejectReportDzo"
									class="table-actions-button btn-red"
								>
									Отклонить
								</button>
							</div>
							<div v-else>
								<h3>Остаток количества</h3>
								<!-- <QuantityLeftChart /> -->
								<line-chart
									:chart-data="chartLineData"
									:height="100"
									:options="this.options"
								/>
								<h3>Остаток в тенге</h3>
								<polar-area
									:chart-data="chartDataPie"
									:height="110"
									:options="this.options"
								/>
								<div class="doughnut-block">
									<div>
										<h3>Продано в количестве</h3>
										<doughnut
											:chart-data="chartDataDoughnutPrice"
											:height="130"
											:options="this.options"
										/>
									</div>
									<div>
										<h3>Продано в тенге</h3>
										<doughnut
											:chart-data="
												chartDataDoughnutWeight
											"
											:height="130"
											:options="this.options"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<a href="#" class="close-auth-modal" @click="closeModal">
						<!-- X close auth icon -->
						<svg
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							x="0"
							y="0"
							viewBox="0 0 32 32"
							style="enable-background: new 0 0 32 32"
							xml:space="preserve"
							width="24"
							height="24"
						>
							<g id="icon-x-close">
								<path
									fill="#ffffff"
									d="M30.3448276,31.4576271 C29.9059965,31.4572473 29.4852797,31.2855701 29.1751724,30.980339 L0.485517241,2.77694915 C-0.122171278,2.13584324 -0.104240278,1.13679247 0.52607603,0.517159487 C1.15639234,-0.102473494 2.17266813,-0.120100579 2.82482759,0.477288136 L31.5144828,28.680678 C31.9872448,29.1460053 32.1285698,29.8453523 31.8726333,30.4529866 C31.6166968,31.0606209 31.0138299,31.4570487 30.3448276,31.4576271 Z"
									id="Shape"
								></path>
								<path
									fill="#ffffff"
									d="M1.65517241,31.4576271 C0.986170142,31.4570487 0.383303157,31.0606209 0.127366673,30.4529866 C-0.12856981,29.8453523 0.0127551942,29.1460053 0.485517241,28.680678 L29.1751724,0.477288136 C29.8273319,-0.120100579 30.8436077,-0.102473494 31.473924,0.517159487 C32.1042403,1.13679247 32.1221713,2.13584324 31.5144828,2.77694915 L2.82482759,30.980339 C2.51472031,31.2855701 2.09400353,31.4572473 1.65517241,31.4576271 Z"
									id="Shape"
								></path>
							</g>
						</svg>
					</a>
				</div>
				<!-- end modal content wrapper -->

				<!-- clickable overlay element -->
				<div class="overlay" @click="closeModal"></div>
			</section>
		</div>
	</div>
</template>

<script>
import { signXml, signXmls } from '@/nclayer/ncalayer';
import { isApproved, isImpl, isRecipient } from '@/variables';
import { mapGetters } from 'vuex';
import Doughnut from '@/views/chart/Doughnut';
import PolarArea from '@/views/chart/PolarArea';
import LineChart from '@/views/chart/LineChart';
import QuantityLeftChart from '@/components/charts/QuantityLeftChart';

export default {
	name: 'ViewTableTwo',
	components: { Doughnut, PolarArea, LineChart, QuantityLeftChart },
	data() {
		return {
			commonReportData: {},
			can_be_sign: false,
			metalPlaces: [],
			reason: '',
			xmlsToSing: '',
			file_url: '',
			excel_url: '',
			pageCount: [],
			xmlToSign: '',
			file: '',
			reports: this.REPORT,
			isApproved: false,
			isImpl: false,
			isRecipient: false,
			historyReports: '',
			options: {
				responsive: true,
				maintainAspectRation: true,
			},
			chartLineData: '',
			chartDataPie: '',
			chartDataDoughnutPrice: '',
			chartDataDoughnutWeight: '',
			// showModal: false,
			showModalEcp: false,
			showModalEcpList: false,
			showModalHistory: false,
			showModalApprovedPersons: false,
			showModalEditApprovedReport: false,
			showModalEditRequest: false,
			showModalRejectDzo: false,
		};
	},
	methods: {
    accessLevel(roles, level) {
      if (roles) {
        let arr = Object.keys(
            JSON.parse(JSON.stringify(this.USER.ouser.role))
        );
        for (const role in arr) {
          if (roles[role].access_level === level) {
            return true;
          }
        }
        return false;
      }
      return false;
    },
		getChangeTitle(old_count_total, count_total) {
			if (old_count_total !== count_total) {
				return 'Старое значение: ' + old_count_total;
			}
			return '';
		},
		getChangeClass(old_count_total, count_total) {
			if (old_count_total !== count_total) {
				return 'modified-cell';
			}
			return '';
		},

		canBeSignedReport() {
			this.$store
				.dispatch('canBeSignedReport', this.$route.params.id)
				.then(response => {
					this.can_be_sign = response.can_be_sign;
				});
		},
		getPlaceData() {
			this.$store
				.dispatch('getMetalPlace', this.$route.params.id)
				.then(response => {
					this.metalPlaces = response.metal_places;
				});
		},
		prettyEmpty(contr_count, value) {
			if (contr_count) {
				return value;
			}
			return '-';
		},
		openMetalPlace() {
			this.$router.push(`/create-report/${this.$route.params.id}/place`);
		},
		downLoadExcel() {
			let formData = {
				reportId: this.$route.params.id,
				month: '',
        year: '',
        company: ''
			};
			this.$store.dispatch('downLoadExcel', formData);
		},
		rmReport() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('rmReport', formData);
		},
		th_union() {
			var metall_color_ths = document.getElementsByClassName(
				'metall-color-th'
			);
			var i = 0;
			var index_fst = 0;
			var inner_text = 'Черный металл';
			var to_remove = [];
			Array.prototype.forEach.call(metall_color_ths, function(el) {
				if (i > 0 && el.innerText == inner_text) {
					var curr_rowspan = metall_color_ths[index_fst].getAttribute(
						'rowspan'
					);
					var next_rowspan = 1;
					if (curr_rowspan) {
						next_rowspan = parseInt(curr_rowspan) + 1;
					}
					metall_color_ths[index_fst].setAttribute(
						'rowspan',
						next_rowspan
					);
					if (i != index_fst) {
						to_remove.push(el);
					}
				} else if (
					i > 0 ||
					(i == 0 && el.innerText == 'Цветной металл')
				) {
					index_fst = i;
					inner_text = 'Цветной металл';
				}
				i += 1;
			});
			Array.prototype.forEach.call(to_remove, function(el) {
				el.remove();
			});
		},
		getChangeColor(changes, columnName) {
			if (changes) {
				for (let i = 0; i < changes.length; i++) {
					if (changes[i].column_name === columnName) {
						return 'modified-cell';
					}
				}
				return '';
			}
			return '';
		},
		getOldTitleValue(changes, columnName) {
			if (changes) {
				for (let i = 0; i < changes.length; i++) {
					if (changes[i].column_name === columnName) {
						return 'Старое значение: ' + changes[i].old_value;
					}
				}
				return '';
			}
			return '';
		},
		downloadFile() {
			window.open(this.file_url);
			// this.$store.dispatch('downloadFile', this.file_url)
		},
		handleFileUpload() {
			this.file = this.$refs.file.files[0];
		},
		inputChanged() {
			const file = document.querySelector('#file'),
				defaultDiv = document.querySelector('.default'),
				successDiv = document.querySelector('.success'),
				parentStateElement = successDiv.parentElement,
				greenBackground = '#36B300';

			let fileName = file.value,
				idxDot = fileName.lastIndexOf('.') + 1,
				extFile = fileName
					.substr(idxDot, fileName.length)
					.toLowerCase();
			if (
				!(
					extFile == 'png' ||
					extFile == 'jpeg' ||
					extFile == 'jpg' ||
					extFile == 'pdf'
				)
			) {
				alert(
					'Следует загружать следующие типы файлов: pdf, png, jpeg, jpg'
				);
				file.value = '';
			} else {
				defaultDiv.style.display = 'none';
				successDiv.style.display = 'inline-block';
				parentStateElement.style.backgroundColor = greenBackground;
			}
		},
		submitFile() {
			this.file = this.$refs.file.files[0];

			let formData = new FormData();
			if (this.file) {
				formData.append('file', this.file);
				formData.append('report_id', this.REPORT.id);
				this.$store.dispatch('sendFile', formData);
			}
		},
		redirectEdit() {
			if (this.REPORT.status === 'Разрешена корректировка') {
				this.$router.push({
					name: 'force-edit-report-item',
					params: { id: this.REPORT.id },
				});
			} else {
				this.$router.push({
					name: 'edit-report-item',
					params: { id: this.REPORT.id },
				});
			}
		},
		getReport() {
			this.$store
				.dispatch('getReport', this.$route.params.id)
				.then(data => {
					if (data.files && data.files.length > 0) {
						this.file_url =
							process.env.VUE_APP_MEDIA_URL +
							data.files[0].file_data;
					}
				});
		},
		getCommonReportData() {
			this.$store
				.dispatch('getCommonReportData', this.$route.params.id)
				.then(data => {
					this.commonReportData = data;
				});
		},
		getHistory() {
			this.$store
				.dispatch('getHistory', this.$route.params.id)
				.then(data => {
					this.historyReports = data;
				});
		},
		signXmlCall() {
			let selectedStorage = 'PKCS12';
			this.xmlToSign = this.REPORT.xmlToSign;
			signXml(selectedStorage, 'SIGNATURE', this.xmlToSign);
		},
		sendSignXml() {
			let signedXml = document.getElementById('signedXml');
			let formData = {
				signedXml: signedXml.value,
				reportId: this.$route.params.id,
			};
			this.$store
				.dispatch('sendSignXml', formData)
				.then(() => {
					location.reload();
					this.$store.dispatch('addNotification', {
						type: 'success',
						message: 'Отчет подписан',
					});
				})
				.catch(error => {
					this.closeModal();
					this.$store.dispatch('addNotification', {
						type: 'error',
						message: 'Отчет не подписан - ' + error.response.data,
					});
				});
		},
		signXmlCallList() {
			let selectedStorage = 'PKCS12';
			//this.xmlsToSing = this.xmlsToSign;
			// let a = new Array();
			signXmls(selectedStorage, 'SIGNATURE', this.xmlsToSing);
		},
		sendSignXmlList() {
			let list_xmls = [];
			for (let i = 0; i < this.xmlsToSing.length; i++) {
				let b = document.getElementById('signedXml_' + i);
				list_xmls.push(b.value);
			}
			let formData = {
				signedXmls: list_xmls,
				reportId: this.$route.params.id,
			};
			this.$store
				.dispatch('sendSignXmls', formData)
				.then(() => {
					location.reload();
					this.$store.dispatch('addNotification', {
						type: 'success',
						message: 'Отчеты были подписаны',
					});
				})
				.catch(error => {
					this.closeModal();
					this.$store.dispatch('addNotification', {
						type: 'error',
						message:
							'Отчеты не подписались - Обратитесь в тех поддержку' +
							error.response.data,
					});
				});
		},
		approvedKmg() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('sendSignXml', formData);
		},
		rejectReport() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('rejectReport', formData);
		},
		rejectReportMetall() {
			let formData = {
				reportId: this.$route.params.id,
			};
			this.$store.dispatch('rejectReportMetall', formData);
		},
		rejectReportDzo() {
			let formData = {
				reportId: this.$route.params.id,
				reason: this.reason,
			};
			this.$store.dispatch('rejectReportDzo', formData);
		},
		getCountNotification() {
			this.$store.dispatch('getCountNotification');
		},
		createDataLineChart() {
			this.chartLineData = {
				labels: [
					['Б/У трубна', 'продукция'],
					'Б/у НКТ',
					['Б/у штанги', 'насосные'],
					['Стальной', 'кусковой лом,', 'отходы'],
					['Прочий лом', 'Черный', 'металлолом'],
					['Алюминий', 'провод АС'],
					['Аккумуляторные', 'батареи'],
					'Медь',
					['Кабельная', 'линия, провод'],
					['Прочий лом', 'Цветной', 'металлолом'],
				],
				datasets: [
					{
						label: 'Остаток на начало месяца',
						//this.REPORT ? this.REPORT.requests ? this.REPORT.requests[0].count_before : null : null,
						data: this.getData('count_before'),
						backgroundColor: 'rgb(99,250,255, 0.2)',
						//borderColor: 'rgba(255, 99, 132, 1)',
					},
					{
						label: 'Прибыло',
						data: this.getData('count_after'),
						backgroundColor: 'rgb(145,235,54, 0.2)',
						//borderColor: 'rgba(54, 162, 235, 1)',
					},
					{
						label: 'Реализовано', //contr_count_gone
						data: this.getData('contr_count_gone'),
						backgroundColor: 'rgba(255, 99, 132, 0.2)',
						//borderColor: 'rgba(54, 162, 235, 1)',
					},
					{
						label: 'Остаток на конец месяца', //count_after
						data: this.getData('count_after'),
						backgroundColor: 'rgba(54, 162, 235, 0.2)',
						//borderColor: 'rgba(54, 162, 235, 1)',
					},
				],
			};
		},
		createDataPieChart() {
			this.chartDataPie = {
				labels: [
					'Б/у трубная продукция',
					'Б/у НКТ',
					'Б/у штанги насосные',
					['Стальной', 'кусковой лом,', 'отходы'],
					['Прочий лом', 'Черный', 'металлолом'],
					['Алюминий', 'провод АС'],
					['Аккумуляторные', 'батареи'],
					'Медь',
					['Кабельная', 'линия, провод'],
					['Прочий лом', 'Цветной', 'металлолом'],
				],
				datasets: [
					{
						data: this.getData('total_after'),
						backgroundColor: [
							'rgba(255, 99, 132, 0.5)',
							'rgba(54, 162, 235, 0.5)',
							'rgba(145, 235, 54, 0.5)',
							'rgb(54,157,235, 0.5)',
							'rgb(235,184,54, 0.5)',
							'rgb(235,54,54, 0.5)',
							'rgba(145, 235, 54, 0.5)',
							'rgb(120,101,101, 0.5)',
							'rgb(54,235,208, 0.5)',
							'rgb(235,54,211, 0.5)',
						],
					},
				],
			};
		},
		createDataDoughnutPrice() {
			this.chartDataDoughnutPrice = {
				labels: [
					'аукцион',
					'реализация через товарную биржу',
					'прямая адресная продажа',
				],
				datasets: [
					{
						data: [15, 19, 31],
						backgroundColor: [
							'rgba(255, 99, 132, 0.5)',
							'rgba(54, 162, 235, 0.5)',
							'rgba(145, 235, 54, 0.5)',
						],
					},
				],
			};
		},
		createDataDoughnutWeight() {
			this.chartDataDoughnutWeight = {
				labels: [
					'аукцион',
					'реализация через товарную биржу',
					'прямая адресная продажа',
				],
				datasets: [
					{
						data: [15, 19, 31],
						backgroundColor: [
							'rgba(255, 99, 132, 0.5)',
							'rgba(54, 162, 235, 0.5)',
							'rgba(145, 235, 54, 0.5)',
						],
					},
				],
			};
		},

		getData(column) {
			var data = [];
			this.REPORT.requests.forEach(function(entry) {
				data.push(entry[column]);
			});
			return data;
		},
		hideRemnantColumns() {
			let metallLeft = document.querySelectorAll(
					'.metall-left-in-stock-botm'
				),
				metallSubColumns = document.querySelectorAll(
					'.metall-left-in-stock-sub-botm'
				),
				metallReceived = document.querySelector('.metall-received'),
				metallReceivedCount = document.querySelector(
					'.metall-received-count'
				),
				metallTdHide = document.querySelectorAll('.metall-td-hide'),
				metallTdHidden = document.querySelectorAll(
					'.metall-slot-hidden'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallLeft.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallReceived.classList.toggle('table-column-hide');
			metallReceivedCount.classList.toggle('table-column-hide');

			metallSubColumns.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallTdHide.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallTdHidden.forEach(item => {
				item.style.display = 'block';
			});

			hideButtons.forEach(item => {
				item.disabled = true;
			});
		},
		showRemnantColumns() {
			let metallLeft = document.querySelectorAll(
					'.metall-left-in-stock-botm'
				),
				metallSubColumns = document.querySelectorAll(
					'.metall-left-in-stock-sub-botm'
				),
				metallReceived = document.querySelector('.metall-received'),
				metallReceivedCount = document.querySelector(
					'.metall-received-count'
				),
				metallTdHide = document.querySelectorAll('.metall-td-hide'),
				metallTdHidden = document.querySelectorAll(
					'.metall-slot-hidden'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallLeft.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallReceived.classList.toggle('table-column-hide');
			metallReceivedCount.classList.toggle('table-column-hide');

			metallSubColumns.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallTdHide.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallTdHidden.forEach(item => {
				item.style.display = 'none';
			});

			hideButtons.forEach(item => {
				item.disabled = false;
			});
		},
		hideContractColumns() {
			let metallInformation = document.querySelector(
					'.metall-information'
				),
				metallInfoContractCell = document.querySelectorAll(
					'.metall-info-contract-cell'
				),
				metallReceivedCount = document.querySelector(
					'.metall-received-count'
				),
				metallTdHide = document.querySelectorAll('.metall-td-hide'),
				metallTdHiddenContract = document.querySelectorAll(
					'.metall-slot-hidden-contract'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallInfoContractCell.forEach(item => {
				item.classList.toggle('table-column-hide');
			});

			metallTdHiddenContract.forEach(item => {
				item.style.display = 'block';
			});

			hideButtons.forEach(item => {
				item.disabled = true;
			});
		},
		showContractColumns() {
			let metallInformation = document.querySelector(
					'.metall-information'
				),
				metallInfoContractCell = document.querySelectorAll(
					'.metall-info-contract-cell'
				),
				metallReceivedCount = document.querySelector(
					'.metall-received'
				),
				metallTdHide = document.querySelectorAll('.metall-td-hide'),
				metallTdHiddenContract = document.querySelectorAll(
					'.metall-slot-hidden-contract'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallInfoContractCell.forEach(item => {
				if (item) {
					item.classList.toggle('table-column-hide');
				}
			});

			metallTdHiddenContract.forEach(item => {
				item.style.display = 'none';
			});

			hideButtons.forEach(item => {
				item.disabled = false;
			});
		},
		hideNotesColumns() {
			let metallInformation = document.querySelector('.metall-notes'),
				metallInfoNotesCells = document.querySelectorAll(
					'.metall-info-notes-cell'
				),
				metallTdHiddenNotes = document.querySelectorAll(
					'.metall-slot-hidden-notes'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallInfoNotesCells.forEach(item => {
				item.classList.toggle('table-column-hide');
			});

			metallTdHiddenNotes.forEach(item => {
				item.style.display = 'block';
			});

			hideButtons.forEach(item => {
				item.disabled = true;
			});
		},
		showNotesColumns() {
			let metallInformation = document.querySelector('.metall-notes'),
				metallInfoNotesCells = document.querySelectorAll(
					'.metall-info-notes-cell'
				),
				metallTdHiddenNotes = document.querySelectorAll(
					'.metall-slot-hidden-notes'
				),
				hideButtons = document.querySelectorAll('.hide-btn');

			metallInfoNotesCells.forEach(item => {
				item.classList.toggle('table-column-hide');
			});

			metallTdHiddenNotes.forEach(item => {
				item.style.display = 'none';
			});

			hideButtons.forEach(item => {
				item.disabled = false;
			});
		},

		openModal() {
			this.showModal = true;
			this.createDataLineChart();
			this.createDataPieChart();
			this.createDataDoughnutPrice();
			this.createDataDoughnutWeight();
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalECP() {
			this.showModalEcp = true;

			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalECPList() {
			this.showModalEcpList = true;

			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalHistory() {
			this.showModalHistory = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalApprovedPersons() {
			this.showModalApprovedPersons = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalEditApprovedReport() {
			this.showModalEditApprovedReport = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalEditRequest() {
			this.showModalEditRequest = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		openModalRejectDzo() {
			this.showModalRejectDzo = true;
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		closeModal() {
			this.showModal = false;
			this.showModalEcp = false;
			this.showModalEcpList = false;
			this.showModalHistory = false;
			this.showModalApprovedPersons = false;
			this.showModalEditApprovedReport = false;
			this.showModalEditRequest = false;
			let body = document.body;
			body.classList.remove('show-auth-modal', 'noscroll');
		},
		getListSignXml() {
			this.$store
				.dispatch('getListSignXml', this.$route.params.id)
				.then(response => {
					this.xmlsToSing = response;
				});
		},
	},

	mounted() {
		this.canBeSignedReport();
		this.getReport();
		this.getCommonReportData();
		this.getPlaceData();
		this.getListSignXml();
		this.getHistory();
		this.getCountNotification();
		this.isApproved = isApproved(this.USER.ouser);
		this.isImpl = isImpl(this.USER.ouser);
		this.isRecipient = isRecipient(this.USER.ouser);
	},
	computed: {
		...mapGetters(['REPORT', 'USER', 'createReportAllowed']),
	},
	updated() {
		//this.th_union();
	},
};
</script>

<style scoped>
a {
	text-decoration: none;
}

.table-container {
	/* overflow-x: auto; */
	padding: 0 2rem;
	min-width: 1800px;
	margin: 0 auto;
}

.table-container-inner {
	padding: 0.5rem;
	margin: 0 2rem;
	/* padding: 1rem 2rem; */
	/* margin-right: 2rem; */
	/* margin: 1rem 2rem; */
	overflow-x: auto;
	max-width: 100vw;
}

.history-sign {
	overflow-x: auto;
	padding: 0 2rem;
	max-width: 1800px;
	margin: 0 auto;
}

table {
	width: 100%;
	border-collapse: collapse;
	text-align: center;
	margin: 0 auto 2rem;
	overflow-x: auto;
	border-bottom: 1px solid black;
}

.table-naming {
	font-size: 2rem;
	font-weight: bold;
	padding: 1rem 0;
	text-align: left;
}

.table-title {
  /* padding: 1rem; */
  padding-bottom: 1rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.table-status {
	margin-bottom: 0.5rem;
}

th,
td {
	border: 1px solid #868686;
	padding: 0 1rem;
}

.expanded {
	padding: 0 2rem;
}

.table-specs {
	background: #36429e;
	width: 100px;
	height: 100px;
	color: white;
	text-align: center;
	border-top-left-radius: 10px;
	border: none;
	font-size: 1.5rem;
	vertical-align: bottom;
}

.tr-fixed-height {
	height: 100px;
}

.t-metall-type {
	height: 296px;
	width: 120px;
}

.t-metall-sub-type {
	width: 130px;
	height: 60px;
}

.metall-left-in-stock-botm,
.metall-left-in-stock-eotm {
	/* width: 180px; */
	height: 75px;
}

.metall-left-in-stock-sub-botm,
.metall-left-in-stock-sub-eotm {
	/* width: 90px; */
	height: 50px;
}

.metall-received {
	position: relative;
	width: 120px;
}

.metall-information,
.metall-notes {
	position: relative;
}

.table-column-hide {
	opacity: 0;
	/*visibility: hidden;*/
	appearance: none;
	display: none;
	visibility: collapse;
}

.table-column-show {
	opacity: 1;
}

.hide-btn,
.show-btn {
	position: absolute;
	top: 0;
	right: 12px;
	padding: 0.5rem;
	background: none;
	border: none;
}

.hide-btn:focus,
.show-btn:focus {
	outline: none;
}

.hide-btn i::before,
.show-btn i::before {
	font-size: 1.2rem;
}

.metall-info-sub-count {
	width: 120px;
}

.metall-info-sub-realization {
	width: 120px;
}

.metall-info-sub-payment {
	width: 90px;
}

.metall-info-sub-naming {
	width: 120px;
}

.metall-info-sub-bin {
	width: 120px;
}

.metall-info-sub-contract-number {
	width: 120px;
}

.metall-info-sub-date {
	width: 110px;
}

.metall-info-sub-price {
	width: 140px;
}

.metall-info-sub-sum {
	width: 140px;
}

.metall-info-sub-exported {
	width: 140px;
}

.metall-info-sub-left {
	width: 140px;
}

/* hidden columns */
.metall-slot-hidden,
.metall-slot-hidden-contract,
.metall-slot-hidden-notes {
	position: relative;
	/* width: 100px; */
	/* height: 75px; */
	display: none;
	border: none;
	/* border-bottom: 1px solid #868686; */
	margin: 0 !important;
}

.metall-slot-hidden p,
.metall-slot-hidden-contract p,
.metall-slot-hidden-notes {
	line-height: 75px;
}

.metall-slot-hidden-notes {
	border-right: 1px solid black;
}

/* History table */
.history-container {
	padding-bottom: 5rem;
}

.history-container h2 {
	text-align: center;
	margin-bottom: 0.5rem;
}

.history-table {
	border-collapse: collapse;
	width: 100%;
	height: 100%;
	max-width: 1460px;
	padding: 1rem;
	border: none;
}

.history-table thead {
	background: #f3f5ff;
	height: 70px;
}

.history-table thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

.history-table thead th:last-child {
	border-top-right-radius: 10px;
}

.history-table th {
	padding: 1rem;
	color: #565656;
}

.history-table tr {
	cursor: pointer;
}

.history-table tr:hover {
	background: #f3f5ff;
}

.history-table td {
	padding: 1rem;
}

.history-table th,
.history-table td {
	border: none;
}

/* .metall-info-contract-cell {
  white-space: nowrap;
} */

.bin-cell {
	white-space: nowrap;
}

/* auth Modal
-----------------------------------------*/
.auth-modal,
.auth-modal .overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 3000;
}

.auth-modal {
	overflow: hidden;
	position: fixed;
	opacity: 0;

	-webkit-transform: translate(500%, 0%);
	transform: translate(500%, 0%);

	-webkit-transition: -webkit-transform 0s linear 0s;
	transition: transform 0s linear 0s;

	/* using flexbox for vertical centering */

	/* Flexbox display */
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;

	/* Vertical alignment */
	-webkit-box-align: center;
	-moz-box-align: center;
	-ms-flex-align: center;
	-webkit-align-items: center;
	align-items: center;

	-webkit-transform-style: preserve-3d;
	-moz-transform-style: preserve-3d;
	transform-style: preserve-3d;
}

.auth-modal .overlay {
	z-index: 0;
	background: rgba(13, 1, 61, 0.82);
	/* overlay color */

	opacity: 0;

	-webkit-transition: opacity 0.2s ease-out 0.05s;
	transition: opacity 0.2s ease-out 0.05s;
}

.auth-modal-content {
	position: relative;
	top: auto;
	right: auto;
	bottom: auto;
	left: auto;
	z-index: 1;

	margin: 0 auto;

	overflow-y: visible;

	background: #000;

	width: calc(100% - 12em);
	height: 0;
	padding-top: calc((100% - 12em) * 0.5625);
	/* 16:9 calc */
}

/* Scaling to fit within the current Viewport size:
   When viewport aspect ratio is greater than 16:9
   work off the height instead of the width for calc */
@media (min-aspect-ratio: 16/9) {
	.auth-modal-content {
		width: 0;
		height: calc(100vh - 10em);
		padding-top: 0;
		padding-left: calc((100vh - 10em) * 1.7778);
		/* 16:9 calc */
	}
}

/* Mobile Layout Tweaks - side margins reduced */
@media (max-width: 640px) {
	.auth-modal-content {
		width: calc(100% - 1em);
		padding-top: calc((100% - 1em) * 0.5625);
		/* 16:9 calc */
	}
}

.close-auth-modal {
	display: block;
	position: absolute;
	left: 0;
	top: -40px;

	text-decoration: none;
	font-size: 20px;
	font-weight: bold;
	color: #fff;
}

.modal-info {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1000;

	display: flex;
	justify-content: center;
	align-items: center;

	/* background: #000; */
	/* box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.5); */
}

.modal-info-inner {
	overflow: scroll;
	background: white;
	padding: 4rem 5rem;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	text-align: center;
	box-shadow: 0px 2px 16px rgba(235, 235, 235, 1);
}

.modalInfoEcp {
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-info-inner h3 {
	font-size: 2rem;
	margin-bottom: 1rem;
}

.auth-moda-explanations {
	margin: 0 0 1rem 0;
}

.auth-choose-cert {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	background: #36429e;
	color: white;
	cursor: pointer;
}

/* Show modal by adding class to body */
.show-auth-modal .auth-modal {
	opacity: 1;

	transform: translate(0%, 0%);
	-webkit-transform: translate(0%, 0%);
}

.show-auth-modal .auth-modal .overlay {
	opacity: 1;
}

.show-auth-modal .auth-modal-content {
	transform: translate(0%, 0%);
	-webkit-transform: translate(0%, 0%);
}

.doughnut-block {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
}

.btns-container {
	display: flex;
}

.table-actions {
	display: flex;
	padding: 2rem 0;
	justify-content: center;
}

.table-actions-button {
	padding: 1rem 2rem;
	border: none;
	outline: none;
	border-radius: 10px;
	margin-left: 1rem;
	cursor: pointer;
	font-size: 1.1rem;
}

.btn-green {
	background: #7ad38d;
	color: white;
}

.btn-yellow {
	background: #ffbb56;
	color: white;
}

.btn-red {
	background: #e86363;
	color: white;
}

.btn-blue {
	background: #6c63e8;
	color: white;
}

.history-report {
	margin: 30px 0 30px 500px;
}

.history {
	margin: 5px 5px 5px 5px;
}

.file-container {
	display: flex;
	justify-content: center;
	margin-left: 20rem;
}

.pdf-container {
	width: 800px;
	height: 800px;
	overflow: scroll;
}

.down-load-container {
	margin-right: 200px;
}

.modified-cell {
	background: #f3f5ff;
	color: black;
}

.table-info {
	display: flex;
	justify-content: space-between;
	padding: 0.5rem;
}

/* Status info */
.status-info {
	position: relative;
	padding: 1rem 2rem;
	border: 1px solid #7ad38d;
	outline: none;
	font-size: 1.1rem;
	border-radius: 10px;
	background: none;
}

.status-info:hover {
	background: #7ad38d;
	color: white;
	cursor: pointer;
}

/* EditApprovedReport Modal */
.edit-approved-report-modal {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 2rem;
}

.edit-approved-report-modal h2 {
	max-width: 600px;
	margin-bottom: 2rem;
}

.uploadScannedDocument {
	border: none;
}

.file-area {
	width: 100%;
	position: relative;
}

.file-area input[type='file'] {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	cursor: pointer;
	border-radius: 25px;
	border: none;
}

.file-area .file-state {
	width: 100%;
	padding: 1rem 1rem;

	border: none;
	border-radius: 10px;
	/* margin-left: 1rem; */
	cursor: pointer;
	font-size: 1.1rem;

	background: #5769f8;
	color: #fff;
	text-align: center;
	transition: background 0.3s ease-in-out;
}

.file-area .file-state .success {
	display: none;
}

.file-area:hover .file-state {
	border: 1px solid #5769f8;
	background: none;
	color: #5769f8;
}

.report-table-s {
	height: 100%;
	border: none;
	font-size: 0.8rem;
	background: none;
	width: 50px !important;
}

.file-area input[type='file']:focus + .file-state {
	/* outline: 2px solid rgba(255, 255, 255, 0.5); */
	/* outline: -webkit-focus-ring-color auto 5px; */
}

/* .file-area input[type=file]:valid+.file-state {
    border-color: #36B300;
    background-color: #36B300;
} */

.file-state-uploaded {
	border-color: #36b300;
	background-color: #36b300;
}

/* Embed file */
.embed-file {
	width: 80%;
	margin: 1.5rem auto;
	max-height: 800px;
	object-fit: contain;
}

/* Reject Block */
.reject-block {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 1.5rem;
}

.reject-block textarea {
	width: 50%;
	height: 20vh;
	border: 1px solid #5769f8;
	border-radius: 20px;
	padding: 1rem;
	resize: none;
}

.reject-block textarea:focus {
	outline: none;
}

.place-view {
	/* margin: 2rem 0 5rem; */
	padding: 2rem 0 3rem;
}

.place-view table td {
	padding: 0.5rem;
}
</style>
